import { getCountries } from "@/lib/api/country";
import { Country } from "@/lib/types/country";
import { defineStore } from "pinia";

interface CountryState {
    countries: Country[]
    loading: boolean
}

export const useCountriesStore = defineStore('countries', {
    state: (): CountryState => ({
        countries: [],
        loading: false,
    }),
    actions: {
        async fetchAll(): Promise<void> {
            this.loading = true

            try {
                const countries = await getCountries()
                this.countries = countries
            } catch (err) {
                console.error(err)
                throw err
            } finally {
                this.loading = false
            }
        }
    }
})